import { useState } from 'react';
import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, Divider, darken, Tooltip } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import TodayRounded from '@mui/icons-material/TodayOutlined';

import AddRounded from '@mui/icons-material/AddRounded';
import SupportAgentRounded from '@mui/icons-material/SupportAgentRounded';
import AutoFixHighRounded from '@mui/icons-material/AutoFixHighRounded';


import { BasicFlex, Notes } from '../../../utils/Common';

import { useQuery, useQueryErrorResetBoundary } from '@tanstack/react-query';

import { getWigOrders } from '../../WigOrders/apiService';


// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { formatCurrency, formatPhoneNumber, formatGenericDateTime, formatGenericTime } from '../../../utils/util';

import Dialog from '../../../utils/utilities/Dialog';
import EditWigOrder from '../../WigOrders/EditWigOrder';

import WigOrderCard from '../../WigOrders/Components/WigOrderCard';

const AddButton = styled(BasicFlex)`
  width: 8rem;
  height: 8rem;
  background-color: ${props => props.theme.colors.darkBg};
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${props => darken(props.theme.colors.darkBg, .1)};
  }
`

// const orders = [
//   {
//     sku: "1234",
//     customer: "John Doe",
//     details: ""
//   }
// ]

const OrderContainer = styled(BasicFlex)`
  flex-wrap: wrap;
`


const OrdersTab = () => {
  const { data = {} } = usePageData();

  console.log(data, "data");

  const { data: orders } = useQuery({
    queryKey: ['wig_orders', data?.customer_id, data?.appointment_id],
    queryFn: () => getWigOrders(data?.customer_id, data?.appointment_id),
    enabled: !!data?.customer_id && !!data?.appointment_id
  })

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12}}>
        <Card variant='outlined'>
          <CardHeader title="Wig Orders" />

          <CardContent>
            <CardBlockContainer $gap="1rem">
              <CardBlockHeader>Appointment Details</CardBlockHeader>
              <CardBlock header="" icon={<AutoFixHighRounded fontSize="small" color="basic" />} info={data.title} spread="2rem" />
              <CardBlock header="" icon={<TodayRounded fontSize="small" color="basic" />} info={formatGenericDateTime(data.start_time)} spread="2rem" />
              <CardBlock header="" icon={<SupportAgentRounded fontSize="small" color="basic" />} info={data.stylist_name} spread="2rem" />
              <CardSpacer />
            </CardBlockContainer>

            <Divider />

            <OrderContainer justify="flex-start" gap="2rem" align="flex-start" my="1.5rem">
              {orders?.map((order, i) => (
                <WigOrderCard key={i} order={order} />
              ))}

            <Dialog
              toggle={<Tooltip title="Add Wig Order"><AddButton><AddRounded fontSize="large" color="basic" /></AddButton></Tooltip>}
              title="Add New Wig Order"
              size="lg"
              useForm={true}
            >
              <EditWigOrder ignore_id={true} appt_info={{
                appointment_id: data.appointment_id,
                customer_id: data.customer_id,
                customer_name: data.customer_name,
                customer_phone: data.customer_phone,
                customer_email: data.customer_email,
                stylist_name: data.stylist_name,
                stylist_id: data.stylist_id,
                appointment_title: data.title,
                appointment_date: data.start_time
              }} />
            </Dialog>

            </OrderContainer>
          </CardContent>

        </Card>
      </Grid>

    

    </Grid>
  );

};

export default OrdersTab;